<template>
    <div style="background:#F4F4F4; padding: 16px;">
        <el-row :gutter="20">
            <!-- 1. 查询表单（新增月度选择、清理按钮） -->
            <el-col class="queryform" :span="24">
                <el-form :inline="true" :model="queryform" class="demo-form-inline toolbar" style="color:#111111; margin-bottom: 16px;"
                    @submit.native.prevent>
                    <!-- 老人姓名 -->
                    <el-form-item label="老人姓名">
                        <el-input v-model="queryform.oldName" placeholder="请输入老人姓名" clearable
                            @keyup.enter.native.prevent="getOldFeeStaticList"></el-input>
                    </el-form-item>
                    <!-- 老人身份证 -->
                    <el-form-item label="老人身份证">
                        <el-input v-model="queryform.oldIdCard" placeholder="请输入老人身份证" clearable
                            @keyup.enter.native.prevent="getOldFeeStaticList"></el-input>
                    </el-form-item>
                    <!-- 查询按钮 -->
                    <el-form-item>
                        <el-button type="primary" style="font-size:13px" icon="el-icon-search" size="small" plain
                            @click="getOldFeeStaticList">查询</el-button>
                    </el-form-item>
                    <!-- 新增：清理绑定记录按钮 -->
                    <el-form-item>
                        <el-button type="danger" style="font-size:13px" icon="el-icon-delete" size="small" plain
                            @click="handleCleanOldBindFee">清空费用</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="warning" style="font-size:13px" size="small" plain
                            @click="generateMonthFee">生成月度缴费单</el-button>
                    </el-form-item>

                    <!-- generateMonthFee -->
                    
                    <el-button type="info" @click="toLead" icon="el-icon-upload" plain>表格导入</el-button>
                </el-form>
            </el-col>

            <!-- 2. 统计表格（适配OldBindMonthFeeStaticVo字段） -->
            <el-col :span="24">
                <el-table :data="tableData"
                        :header-cell-style="{
                            'text-align': 'center',
                            'font-weight': '600',
                            color: '#2d2d2d',
                            'background-color': '#d4f5fa',
                        }"
                        :cell-style="{ 'text-align': 'center','font-size': '13px' }"
                        :row-style="tableRowStyle"
                        border
                        style="width: 100%; background: #fff;">
                    <!-- 适配OldBindMonthFeeStaticVo字段：oldmanName/oldmanId/bedFee等 -->
                    <el-table-column prop="oldmanName" label="姓名" width="80px" align="center"></el-table-column>
                    <!-- <el-table-column prop="sex" label="性别" width="60px" align="center">
                        <template slot-scope="scope">
                            <p v-if="scope.row.sex === 0">男</p>
                            <p v-else-if="scope.row.sex === 1">女</p>
                            <p v-else>-</p>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="oldIdCard" label="身份证号" width="160px" align="center"></el-table-column>
                    <el-table-column prop="registryTime" label="入院日期" min-width="100px" align="center">
                    </el-table-column>
                    <!-- 核心统计字段：与OldBindMonthFeeStaticVo对应 -->
                    <el-table-column prop="bedFee" label="床位费" min-width="80px" align="center">
                        <template slot-scope="scope">{{ scope.row.bedFee ? scope.row.bedFee.toFixed(2) : '0.00' }}</template>
                    </el-table-column>
                    <el-table-column prop="careFee" label="护理费" min-width="80px" align="center">
                        <template slot-scope="scope">{{ scope.row.careFee ? scope.row.careFee.toFixed(2) : '0.00' }}</template>
                    </el-table-column>
                    <el-table-column prop="foodFee" label="餐饮费" min-width="80px" align="center">
                        <template slot-scope="scope">{{ scope.row.foodFee ? scope.row.foodFee.toFixed(2) : '0.00' }}</template>
                    </el-table-column>
                    <el-table-column prop="otherName" label="其他费用名称" min-width="120px" align="center">
                        <template slot-scope="scope">{{ scope.row.otherName || '-' }}</template>
                    </el-table-column>
                    <el-table-column prop="otherFee" label="其他费用金额" min-width="80px" align="center">
                        <template slot-scope="scope">{{ scope.row.otherFee ? scope.row.otherFee.toFixed(2) : '0.00' }}</template>
                    </el-table-column>
                    <el-table-column prop="totalFee" label="费用合计" min-width="80px" align="center">
                        <template slot-scope="scope">{{ scope.row.totalFee ? scope.row.totalFee.toFixed(2) : '0.00' }}</template>
                    </el-table-column>
                </el-table>

                <!-- 分页控件（复用原逻辑） -->
                <el-pagination 
                    style="color:#333; text-align: center; margin-top:15px;" 
                    background
                    layout="total, prev, pager, next" 
                    :total="total" 
                    :page-size="pageSize"
                    :current-page="pageNum"
                    @current-change="changePage">
                </el-pagination>
            </el-col>
        </el-row>

        <!-- 3. 清理确认弹窗（防误操作） -->
        <el-dialog
            title="警告：清理月度绑定记录"
            :visible.sync="cleanDialogVisible"
            width="400px"
            :close-on-click-modal="false"
            :before-close="handleDialogClose">
            <div style="color: #f56c6c; margin-bottom: 16px;">
                此操作将删除【{{ queryform.oldName || '所有老人' }}】在【{{ queryform.monthStr || '所有月份' }}】的月度费用绑定记录，数据删除后不可恢复！
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cleanDialogVisible = false">取消</el-button>
                <el-button type="danger" @click="submitCleanOldBindFee">确认清理</el-button>
            </div>
        </el-dialog>


        <!-- 报表上传 -->
      <el-dialog title="月度费用导入" width="30%" :visible.sync="toLeadVisisble" :close-on-click-modal="false">
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-row>
              <el-col :span="24">
                <input type="file" ref="file" id="file" @change="getUrl" />
              </el-col>
            </el-row>
            <el-button  type="primary" size="mini" @click="downMoban" style="margin-top: 40px;">导入模版下载</el-button>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="toLeadVisisble = false">取消</el-button>
          <el-button type="primary" @click.native="intoForm">确定</el-button>
        </div>
      </el-dialog>

    </div>
</template>

<script>
import { baseURL } from "@/utils/request.js";
export default {
    name: "financeOldMonthFeeBind", // 组件名：明确功能
    data() {
        return {
            // 1. 查询表单（新增monthStr：月度统计条件）
            queryform: {
                oldName: '',       // 老人姓名
                oldmanIdCard: '',  // 老人身份证
                monthStr: '',      // 统计月份（格式：yyyy-MM，如2024-05）
            },
            // 2. 表格数据（适配OldBindMonthFeeStaticVo）
            tableData: [],
            total: 0,         // 总条数
            pageNum: 1,       // 当前页
            pageSize: 10,     // 每页条数
            // 3. 清理弹窗控制
            cleanDialogVisible: false,
            toLeadVisisble:false,
            toLeadForm: null,
            fileFlag: false,
        };
    },
    methods: {

        toLead(){
            this.uploadFile = null;
            this.toLeadVisisble = true;
        },
        getUrl(event) {
          let file = event.target.files;
          console.log(file);
          this.fileFlag = true; //by guo 2020-8-4-15:18添加
          this.toLeadForm = new FormData();
          this.toLeadForm.append("file", file[0]);
        },
        downMoban(){
            window.location.href = baseURL + `omc/api/downBindFeeTemplate`;
        },
        intoForm(){
            if (this.fileFlag) {
                  this.$postFormData("omc/Oldman/toLeadOldManFee", this.toLeadForm).then((res) => {
                    this.toLeadVisisble = false;
                    this.fileFlag = false;
                    this.toLeadForm = {};
                    if (res.code == 200) {
                      this.$message({ message: res.message, type: "success" });
                      this.getOldFeeStaticList();
                    } else {
                      this.$message({ message: res.message, type: "error" });
                    }
                  });
            } else {
                  this.$message({ message: "请选择文件", type: "error" });
            }
        },
        // 1. 分页切换
        changePage(val) {
            this.pageNum = val;
            this.getOldFeeStaticList(); // 切换页后重新查询
        },

        // 2. 表格行样式（复用原逻辑）
        tableRowStyle({ rowIndex }) {
            return rowIndex % 2 === 0 
                ? { "background-color": "#ffffff" } 
                : { "background-color": "#e4f5f8" };
        },

        /**
         * 3. 核心：查询老人月度费用统计（对接/queryOldBindMonthFeeStatic）
         * 替换原getOldFeeList（原逻辑基于消费记录计算，现直接用聚合后的统计接口）
         */
        getOldFeeStaticList() {
            // 1. 构建请求参数（含分页、查询条件）
            const param = {
                // 老人筛选条件
                oldName: this.queryform.oldName,
                oldmanIdCard: this.queryform.oldmanIdCard,
                // 分页条件
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            };

            // 2. 调用后端统计接口
            this.$postJson("omc/account/queryOldBindMonthFeeStatic", param)
                .then((res) => {
                    console.log(res);
                    if (res.code == 200 && res.result) {
                        // 3. 适配表格数据（直接使用接口返回的OldBindMonthFeeStaticVo列表）
                        this.tableData = res.result.list || [];
                        this.total = Number(res.result.total) || 0; // 总条数
                    } else {
                        this.$message.error("查询统计数据失败：" + (res.message || "未知错误"));
                        this.tableData = [];
                        this.total = 0;
                    }
                })
                .catch((err) => {
                    this.$message.error("查询接口异常：" + err.message);
                    this.tableData = [];
                    this.total = 0;
                });
        },
        generateMonthFee(){
             this.$postJson("omc/account/generateMonthFee", {})
                .then((res) => {
                    this.cleanDialogVisible = false; // 关闭弹窗
                    if (res.success && res.result !== undefined) {
                        this.getOldFeeStaticList(); // 清理后重新查询，刷新表格
                    } else {
                        this.$message.error((res.message || "未知错误"));
                    }
                })
                .catch((err) => {
                });
        },
        /**
         * 4. 核心：清理老人月度绑定记录（对接/cleanOldBindMonthFee）
         * 步骤1：打开确认弹窗
         */
        handleCleanOldBindFee() {
            // 校验：至少选择“月份”或“老人条件”（避免误删全部数据）
            // 打开确认弹窗
            this.cleanDialogVisible = true;
        },

        /**
         * 步骤2：确认清理（调用接口）
         */
        submitCleanOldBindFee() {
            // 构建清理参数（与查询参数一致，确保清理范围精准）
            const param = {
                oldName: this.queryform.oldName,
                oldmanIdCard: this.queryform.oldmanIdCard,
            };

            this.$postJson("omc/account/cleanOldBindMonthFee", param)
                .then((res) => {
                    this.cleanDialogVisible = false; // 关闭弹窗
                    if (res.success && res.result !== undefined) {
                        this.$message.success(`清理成功！共删除 ${res.result} 条绑定记录`);
                        this.getOldFeeStaticList(); // 清理后重新查询，刷新表格
                    } else {
                        this.$message.error("清理失败：" + (res.message || "未知错误"));
                    }
                })
                .catch((err) => {
                    this.cleanDialogVisible = false;
                    this.$message.error("清理接口异常：" + err.message);
                });
        },

        // 5. 关闭清理弹窗（重置状态）
        handleDialogClose() {
            this.cleanDialogVisible = false;
        },
    },
    mounted() {
        // 页面加载时：默认查询当前月份的统计数据
        // 加载数据
        this.getOldFeeStaticList();
    },
};
</script>

<style scoped>
/* 优化表单间距 */
.demo-form-inline .el-form-item {
    margin-right: 16px;
    margin-bottom: 12px;
}
/* 表格边框优化 */
.el-table--border th, .el-table--border td {
    border-right: 1px solid #e4e7ed;
}
</style>